import apiService from './apiService'

export default {
  getRunnerCoordinates(raceId, runnerId) {
    return apiService.get(`api/locations/${raceId}/runners/${runnerId}/coordinates`)
  }
}



// WEBPACK FOOTER //
// ./src/services/locationService.js